<!-- 听评课分析 -->
<template>
  <div class="listen-lesson">
    <div class="listen-lesson-title">
      <div class="name">听评课分析</div>
    </div>
    <div class="listen-lesson-number">
      <div class="listen-lesson-activity">
        <div class="tips"></div>
        <div class="title">总活动（个）</div>
        <div class="number">{{tpkNum}}</div>
      </div>
      <div class="listen-lesson-list">
        <div class="tips"></div>
        <div class="title">评课表 （个）</div>
        <div class="number">{{pkbNum}}</div>
      </div>
    </div>
    <div class="listen-lesson-table">
      <el-row class="top" type="flex">
        <el-col :span="8">学校名称</el-col>
        <el-col :span="8">创建次数</el-col>
        <el-col :span="8">总参与人数</el-col>
      </el-row>
      <el-row class="content" type="flex" v-for="item,index in schoolList" :key="index">
        <el-col :span="8" class="school-info"><div class="school-name" :title="item.schoolName">{{item.schoolName}}</div></el-col>
        <el-col :span="8">{{item.creatNumber}}</el-col>
        <el-col :span="8">{{item.joinNumber}}</el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {getPlatformSchoolListeningEvaluatingStatAPI} from "@/service/api.js"
export default {
  name: 'listen-lesson',
  components: {
  },
  props:{
    //区域id
    regionId:{
      type:String,
      default:""
    },
    //区域平台类型
    regionType:{
      type:String,
      default:""
    },
    //区域平台名称
    regionName:{
      type:String,
      default:""
    },
    //省id
    provinceId:{
      type:String,
      default:''
    },
    //市id
    cityId:{
      type:String,
      default:''
    },
    //区id
    districtId:{
      type:String,
      default:''
    },
    //乡镇地址
    address:{
      type:String,
      default:''
    },
    //开始时间
    startTime:{
      type:String,
      default:""
    },
    //结束时间
    endTime:{
      type:String,
      default:""
    },
    pkbNum:{
      type:Number,
      default:0
    },
    tpkNum:{
      type:Number,
      default:0
    },
    //局端听评课数量
    regionTpkNum:{
      type:Number,
      default:0
    },
    //局端听评课参加人数
    regionTpkJoinNum:{
      type:Number,
      default:0
    },
  },
  data() {
      return {
        schoolList:[],
      }
  },
  watch:{
    startTime(){
      this.getPlatformSchoolListeningEvaluatingStat();
    },
    endTime(){
      this.getPlatformSchoolListeningEvaluatingStat();
    },
    address(){
      this.getPlatformSchoolListeningEvaluatingStat();
    }
  },
  methods: {
    /**
     * @name 获取平台学校听评课统计
     */
    getPlatformSchoolListeningEvaluatingStat(){
      let params = {
        regionId:this.regionId,
        startTime:this.startTime?`${this.startTime} 00:00:00` :'',
        endTime:this.endTime ? `${this.endTime} 23:59:59` :'',
        keyWord:"",
        page:1,
        limit:10,
        provinceId:this.provinceId,
        cityId:this.cityId,
        districtId:this.districtId,
        address:this.address,
        regionType:this.regionType
      }
      getPlatformSchoolListeningEvaluatingStatAPI(params).then((res)=>{
        this.schoolList = res.rows.map((item)=>{
          return {
            schoolName:item.schoolName,
            schoolId:item.schoolId,
            creatNumber:item.tpkNum,
            joinNumber:item.tpkJoinNum
          }
        })
        if(this.regionTpkNum > 0 && this.regionTpkNum > this.schoolList[this.schoolList.length - 1].creatNumber){
          this.schoolList.push({
            schoolName:this.regionName,
            schoolId:this.regionId,
            creatNumber:this.regionTpkNum,
            joinNumber:this.regionTpkJoinNum
          })
        }
        this.schoolList.sort((a,b) => {
          return b.creatNumber - a.creatNumber
        })
        if(this.schoolList.length > 10){
          this.schoolList.length = 10
        }
      }).catch((err)=>{})
    },
  },
  mounted(){
    //获取平台学校听评课统计
    this.getPlatformSchoolListeningEvaluatingStat();
  },
}
</script>

<style lang="scss" scoped>
.listen-lesson{
  width: 100%;
  .listen-lesson-title{
    // color:#fff;
    // height: 40px;
    // width:100%;
    background: url("~@/assets/images/qxdataboard/head-bg.png") no-repeat ;
    background-size:100% 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px;
    height: 40px;
    .name{
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
    }
  }
  .listen-lesson-number{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    margin-top: 20px;
    width: 100%;
    .tips{
      width: 10px;
      height: 10px;
      border-radius: 50%;
      margin-right: 4px;
    }
    .title{
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #C4D6F2;
      margin-right: 15px;
    }
    .number{
      font-size: 32px;
      font-family: MaravaleExpanded;
      font-weight: normal;
      color: #6FEFFF;
      @font-face {
        font-family: MaravaleExpanded;
        src: url('../../../assets/fonts/digifaw.ttf'); //字体路径
      }
    }
    .listen-lesson-activity,
    .listen-lesson-list{
      display: flex;
      align-items: center;
    }

    .listen-lesson-activity{
      .tips{
        background: #FFDF25;
      }
    }
    .listen-lesson-list{
      .tips{
        background: #2391FF;
      }
    }
  }
  .listen-lesson-table{
    // background-color:transparent;
    text-align: center;
    padding-bottom: 20px;
    .top{
      width: 100%;
      padding: 0 15px;
      height: 32px;
    }
    .content{
      width: 100%;
      padding: 0 15px;
      height: 45px;
      border: 1px solid #14326C;
      .school-name{
        width: 120px;
        text-align: left;
        overflow:hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow:ellipsis;
      }
    }
  }
}
</style>
<style lang="scss">
.listen-lesson{
  .listen-lesson-table{
    .top{
      .el-col{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #5B90E6;
      }
    }
    .content{
      .el-col{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #C4D6F2;
      }
    }
  }
}
</style>